import axios from 'axios';
import URLS from './urls';

const apiClient = axios.create({
  baseURL: URLS.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 응답 인터셉터
apiClient.interceptors.response.use(
  (response) => {
    const { resultCode, resultMessage } = response.data;

    // resultCode가 200이 아님 → 에러 처리
    if (resultCode && resultCode !== 200) {
      alert(resultMessage || '서버와의 통신 중 에러가 발생했습니다.');
      console.error(`API error 발생\nresultCode : ${resultCode}\nresultMessage : ${resultMessage}`);

      // 에러를 throw해서 상위에서 catch 가능하도록
      return Promise.reject(new Error(resultMessage || 'API Error'));
    }

    return response;
  },
  (error) => {
    alert(error.message || '네트워크 오류가 발생했습니다.');
    console.error(`API error 발생\n${error}`);

    return Promise.reject(error);
  }
);

export const isRelease = URLS.baseUrl === 'https://store.kkoruruk-prod.com';

export default apiClient;
